import { SidebarNavigationRouteType } from "@/store/navigation/types";
import sidebarData from "@/data/docs/sidebar.json";

export const sidebarNavData: SidebarNavigationRouteType[] =
  Object.values(sidebarData);
